import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { messengerActions } from 'srcReact/MessengerPage'
import { Alert } from 'srcReact/components/common2/Alert'
import toast from 'react-hot-toast'
import InputArea from 'srcReact/MessengerPage/components/InputArea'

export default function EditMessage({ messageProp, user, editModeMessage, unsetEditMode, isMessageAppended }) {
  const [editConfirmed, setEditConfirmed] = useState(false)
  const dispatch = useDispatch()
  //const [content, setContent] = useState(messageProp.message)
  const editorRef = useRef()
  const [errorFromInputArea, setErrorFromInputArea] = useState('')
  const {
    messenger: { loadingEditMessage, isMessageEdited, openedConversation }
  } = useSelector((state) => state)

  const editMessage = (content) => {
    if (errorFromInputArea.length > 0) {
      toast.custom((toastProps) => (
        <Alert text={errorFromInputArea} type='error' onRemoveAlert={handleRemoveAlert} toastProps={toastProps} />
      ))
    } else {
      if (messageProp) {
        dispatch(messengerActions.updateMessage(messageProp.id, content))
        setEditConfirmed(true)
      }
    }
  }

  const handleRemoveAlert = () => {
    setErrorFromInputArea('')
  }
  useEffect(() => {
    if (isMessageEdited && editConfirmed) {
      unsetEditMode()
    }
  }, [isMessageEdited])

  return (
    <InputArea
      isEditMode={true}
      editEditorId={`editMessage${messageProp.id}`}
      handleExitEditMode={unsetEditMode}
      handleEdit={editMessage}
      existingMessage={editModeMessage.message}
      editEditorRef={editorRef}
    />
  )
}
